import type { ImageProps } from 'next/legacy/image';
import Step1 from '../images/hiw-step-1.png';
import Step2 from '../images/hiw-step-2.png';
import Step3 from '../images/hiw-step-3.png';

// StaticImageData (PNG imports) is compatible with ImageProps.src; alt is added at call site
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getImageProps = (src: any): Omit<ImageProps, 'alt'> =>
    typeof src === 'string' ? { src } : { src };

export const steps = () => [
    {
        title: __('Write a design brief'),
        body: __(
            'Describe the vision you have for your design in our quick and easy-to-use brief.'
        ),
        image: {
            ...getImageProps(Step1),
            alt: __('A person saying that they need a logo and filling out a design brief'),
        },
    },
    {
        title: __('Connect with designers'),
        body: __(
            "We've got two ways of working  guaranteed to connect you with a professional designer that's right for you. <Link>Find out more</Link>"
        ),
        image: {
            ...getImageProps(Step2),
            alt: __('Four different designers submitting their designs'),
        },
    },
    {
        title: __('Collaborate on your design'),
        body: __(
            'Work with your chosen designer to get expert help in bringing your brand and business to life.'
        ),
        image: {
            ...getImageProps(Step3),
            alt: __('A person saying they love the design and selecting it as the winner'),
        },
    },
];
